import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import {
  Typography,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
  CircularProgress,
  Box,
  Grid,
  styled,
  useTheme,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
// import { Document, Page } from "react-pdf"
import { FormatColorResetTwoTone } from '@mui/icons-material';

//import { mainStyles, theme } from "../../styles/Main.js"
import {
  CustomCounterAppBar,
  CustomLoadingOverlay,
  LocationDialogComponent,
  GenericContainer,
  CustomAlertMaterial,
  Buttons,
  AlertConfirm,
  GenericContainerForm,
  ButtonsLinedCustom,
} from '../../components';
import VisorPDF from '../../components/Visor/VisorPDF';
import {
  documentsActions,
  fileActions,
  workflowActions,
  addTitleLegoCurrent,
} from '../../store/actions';
import { useStyles } from './DocumentSignStyles';
import { b64toUrl, coreFunctions, GetMimeType, IsDevice } from '../../utils';
import { useTranslation } from 'react-i18next';
import RejectDocuments from './RejectDocument';

const LabelCustom = styled(FormControlLabel)(({ theme }) => ({
  margin: '0px !important',
  '& .MuiFormControlLabel-root': {
    margin: '0px !important',
  },
  '& .PrivateSwitchBase-root': {
    padding: '5px !important',
  },
  label: {
    margin: '0px !important',
  },
}));

export default function DocumentViewerCheckCarrusel(props) {
  const matches = useMediaQuery('(max-width:812px)');
  const { useState, useEffect } = React;
  const gridContainer = {}; //mainStyles.gridStyle();
  const localStyles = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const location = useLocation();
  const classes = {}; //mainStyles.bodyStyles()//estílos genéricos (Main.js)
  const ctrlCheckRef = useRef();
  const [containerHeight, setContainerHeight] = useState(80);
  const { t } = useTranslation();

  const [currentStage, setCurrentStage] = useState(0);
  const [totalStage, setTotalStage] = useState(0);
  const [stageName, setStageName] = useState('');
  const [docTypes, setDocTypes] = useState({});
  const [response, setResponse] = useState('');
  const [checkState, setCheckState] = useState(false);
  const [openLocation, setOpenLocation] = useState(false);
  const [loadView, setLoadView] = useState(false); //Se muestra/oculta el gif loader
  const [isOneList, setIsOneList] = useState(false);
  const [fileUrl, setfileUrl] = useState(null);
  const [loadFileInfo, setLoadFileInfo] = useState(false);

  const [cancelAlert, setCancelAlert] = useState(false);
  const [cancelAction, setCancelAction] = useState(false);

  const [listDocumentsAcepted, setListDocumentsAcepted] = useState([]);
  const [documentCurrentId, setDocumentCurrentId] = useState(0);
  const [documentCurrentName, setDocumentCurrentName] = useState('');
  const [activeContinueButton, setActiveContinueButton] = useState(false);
  const [previous, setPrevious] = useState(false);
  const [isPrevDoc, setIsPrevDoc] = useState(false);

  //Redux hooks
  const auth = useSelector((state) => state.Authentication);
  const file = useSelector((state) => state.FileInfo);
  // const wf = useSelector((state) => state.Workflow);
  const pdfDoc = useSelector((state) => state.Document);
  const cancelWF = useSelector((state) => state.CancelWorkFlow);

  const dispatch = useDispatch();

  useEffect(() => {
    console.log('location.state*********: ', location.state);
    if (
      location.state?.stage?.Properties?.some(
        (prop) => prop.Name === 'SignatureType' && prop.Value === 'Avanzada',
      )
    ) {
      const { stage, folioId } = location.state;

      let nextComponent = 'AdvancedSignViewer';
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: {
          stageName: stage.Name,
          stageId: stage.Id,
          folioId: folioId,
        },
      });
    } else {
      setfileUrl(null);
      dispatch(fileActions.GetFileInfo(location.state.folioId));
      sessionStorage.setItem('properties', null);
      setLoadFileInfo(true);
      setLoadView(true);
      handleResize();
    }
  }, []);

  useEffect(() => {
    dispatch(addTitleLegoCurrent('Firma de documentos'));
    // Agregar el event listener en el montaje del componente
    window.addEventListener('resize', handleResize);

    // Limpiar el event listener en el desmontaje del componente
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    console.log('........file.items.............: ', loadFileInfo, file.items);
    if (file.items != undefined && file.items != null && loadFileInfo) {
      console.log('file.items: ', file.items);
      getStageProperties(file.items);
      setLoadView(false);
      setLoadFileInfo(false);
      setActiveContinueButton(false);
    } else if (file.error != undefined && file.error != null && loadFileInfo) {
      setLoadView(false);
      setLoadFileInfo(false);
    }
  }, [file]);

  useEffect(() => {
    if (cancelWF.items != undefined && cancelAction) {
      setLoadView(false);
      console.log('cancelWF.items*********************: ', cancelWF.items);
      if (cancelWF.items?.Stage != null) {
        let nextStage = cancelWF.items?.Stage;
        let stageName = nextStage.Name;
        let stageId = nextStage.Id;
        let folioId = file.items.Id;
        let stage = cancelWF.items?.Stage;

        let nextComponent = coreFunctions.GetLegoNext(stageName);
        coreFunctions.DoNextStage({
          navigate,
          nextComponent,
          State: { stageName, stageId, stage, folioId },
        });
      }
    }
  }, [cancelWF]);

  useEffect(() => {
    console.log('pdfDoc.items.............: ', pdfDoc.items);
    if (pdfDoc.items != undefined) {
      setfileUrl(null);
      let pdfB64 = pdfDoc.items.B64Content;
      if (pdfB64 != undefined && pdfB64 != null) {
        async function fetchData() {
          const blobUrl = await b64toUrl(`${GetMimeType('.pdf')},${pdfB64}`);
          setfileUrl(blobUrl);
          setLoadView(false);
        }
        fetchData();
      }
    }
  }, [pdfDoc]);

  useEffect(() => {
    console.log('document current id: ', documentCurrentId);
    if (documentCurrentId > 0) {
      dispatch(documentsActions.DownloadDocument(documentCurrentId));
    }
  }, [documentCurrentId]);

  useEffect(() => {
    if (listDocumentsAcepted.length > 0) {
      console.log('**********------listDocumentsAcepted----************: ', listDocumentsAcepted);
      sessionStorage.setItem('properties', JSON.stringify(listDocumentsAcepted));
      console.log(
        "**********------sessionStorage.getItem('properties')----************: ",
        sessionStorage.getItem('properties'),
      );

      let pendientesCapturar = listDocumentsAcepted.filter((item) => item.Captured === null);
      console.log('pendientesCapturar', pendientesCapturar);
      if (pendientesCapturar?.length > 0) {
        let documentCurrent = pendientesCapturar[0]?.Document;
        setDocumentCurrentId(documentCurrent?.Id ?? 0);
        dispatch(addTitleLegoCurrent(documentCurrent?.Name ?? 'Firma de documentos'));
        // setDocumentCurrentName(documentCurrent?.Name ?? "Documento")
        if (checkState) {
          ctrlCheckRef.current.click();
        }
      } else {
        setActiveContinueButton(true);
        handleAcceptDocument();
      }
    }
  }, [listDocumentsAcepted]);

  let getStageProperties = (element) => {
    // let documentTypes1 = element.Stage.DocumentalCategory.DocumentalGroups[0].DocumentTypes?.filter(item => item.Document != null)
    const documentTypes1 = element.Stage.DocumentalCategory.DocumentalGroups.flatMap(
      (group) => group.DocumentTypes?.filter((item) => item.Document != null) || [],
    );
    console.log('documentTypes1*****************: ', documentTypes1);
    let newData = documentTypes1.map((data, index) => {
      return {
        ...data,
        CurrentIndex: index,
        Captured: null,
      };
    });
    console.log('newData*****************: ', newData);
    setListDocumentsAcepted(newData);
    setTotalStage(element.Stage.TotalStageGroups);
    setCurrentStage(element.Stage.CurrentStageGroup);
  };

  let handleAcceptDocument = () => {
    if (!activeContinueButton) {
      let indexArray = listDocumentsAcepted?.filter(
        (item) => item.Document.Id === documentCurrentId,
      )[0];
      console.log('indexArray: ', indexArray);

      let newArr = [...listDocumentsAcepted];
      console.log('newArr: ', newArr);
      newArr[indexArray.CurrentIndex].Captured = true;
      console.log('newArr******', newArr);
      setListDocumentsAcepted(newArr);
      console.log('Pasa al siguiente documento');
      setPrevious(true);
    } else {
      let nextStage = file.items.Stage;
      let stageName = nextStage.Name;
      let stageId = nextStage.Id;
      let folioId = file.items.Id;
      let stage = file.items.Stage;
      let nextComponent = 'SignHelp';
      console.log('{ auth ,navigate,nextComponent, stageName, stageId, stage, folioId }: ', {
        navigate,
        nextComponent,
        stageName,
        stageId,
        stage,
        folioId,
      });
      coreFunctions.DoNextStage({
        navigate,
        nextComponent,
        State: { stageName, stageId, stage, folioId },
      });
    }
  };

  const handleResize = () => {
    const windowHeight = window.innerHeight;
    const newHeight = windowHeight > 900 ? 75 : 70;
    console.log('............newHeight.......handleResize............', windowHeight, newHeight);
    setContainerHeight(newHeight);
  };

  const handlePrevious = () => {
    const docIndex = listDocumentsAcepted.findIndex((doc) => doc.Document.Id === documentCurrentId);
    // Si es el primer documento, no hacer nada
    if (docIndex <= 0) return;
    // Desbloquear el botón Previous si no hay más documentos previos
    setPrevious(docIndex - 1 > 0);
    // Obtener el documento anterior
    const prevDoc = listDocumentsAcepted[docIndex - 1];

    if (prevDoc) {
      const {
        Document: { Id, Name },
        Captured,
      } = prevDoc;
      // Descargar y visualizar el documento anterior
      dispatch(documentsActions.DownloadDocument(Id));
      setDocumentCurrentId(Id);
      dispatch(addTitleLegoCurrent(Name ?? 'Firma de documentos'));
      // Control para saber si está en un documento previo
      setIsPrevDoc(true);
      // Ejecutar el control del check si ya capturo
      if (Captured && !checkState) ctrlCheckRef.current.click();
    }
  };

  const handleNext = () => {
    console.log('handleNext::');
    setPrevious(true);
    const docIndex = listDocumentsAcepted.findIndex((doc) => doc.Document.Id === documentCurrentId);
    // Si es el último documento, no hacer nada
    if (docIndex >= listDocumentsAcepted.length - 1) return;
    // Obtener el siguiente documento
    const nextDoc = listDocumentsAcepted[docIndex + 1];

    if (nextDoc) {
      const {
        Document: { Id, Name },
        Captured,
      } = nextDoc;
      // Si no está capturado, indicar que no es un documento previo
      setIsPrevDoc(Captured);
      // Descargar y visualizar el documento siguiente
      dispatch(documentsActions.DownloadDocument(Id));
      setDocumentCurrentId(Id);
      dispatch(addTitleLegoCurrent(Name ?? 'Firma de documentos'));
      // Si no está capturado y el estado del check está activo, ejecutar el control
      if (!Captured && checkState) ctrlCheckRef.current.click();
    }
  };

  return (
    <GenericContainer>
      <Typography variant="subtitle1">{t('legal_read')}</Typography>
      <GenericContainerForm dynamicSize={window.innerHeight > 900 ? 300 : 315}>
        <VisorPDF pdfUrl={fileUrl} porcentaje={containerHeight} />
      </GenericContainerForm>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
          marginTop: 0,
          marginBottom: IsDevice().IsMobile ? 34 : 0,
          paddingBottom: IsDevice().IsMobile ? 34 : 3,
        }}
      >
        {!activeContinueButton ? (
          <LabelCustom
            // className={localStyles.controlLabel}
            value={'TextCheck'}
            control={
              <Checkbox
                ref={ctrlCheckRef}
                color="primary"
                checked={checkState}
                onChange={(e) => {
                  console.log('e.target.checked: ', e.target.checked);
                  setCheckState(e.target.checked);
                }}
                value={'TextCheck'}
              />
            }
            label={<Typography variant="subtitle2">{t('legal_read_auth')}</Typography>}
            labelPlacement="end"
          />
        ) : null}
        <Box mt={1}></Box>

        <ButtonsLinedCustom
          disabledConfirm={activeContinueButton || checkState ? false : true}
          ConfirmButtonText={
            isPrevDoc ? t('general_next_2') : checkState ? t('general_accept') : t('general_next')
          }
          onClickConfirm={isPrevDoc ? handleNext : handleAcceptDocument}
          disabledCancel={!previous}
          CancelButtonText={t('general_prev')}
          // onClickCancel={handlePrevious}
          onClickCancel={previous ? () => handlePrevious() : null}
          sx={{ flexDirection: 'row-reverse', alignItems: 'center' }}
          customControl={
            <RejectDocuments documentId={documentCurrentId} fileId={file.items?.Id} height={35} />
          }
        />
      </Box>
      {loadView ? (
        <CustomLoadingOverlay active={false} text={t('general_loading_message')} />
      ) : null}
    </GenericContainer>
  );
}
